"use strict";

import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { cssLinks } from "@ttark/css-links";
import { RemixPage } from "~/utils/remix-page";
import { $FeedData, $PageLevelTraffic } from "shared/atoms";
import { FeedBody } from "@feed/body";
import { EPageType } from "shared/models/page-type";
import { FeedHead } from "@feed/head";
import { buildMasterLoader } from "~/utils/build-master-loader";
import { ECategoryNameIDMap } from "shared/models/legacy";
var links = () => [...cssLinks("routes/feed.$category_name")];
var loader = buildMasterLoader("feed");
var shouldRevalidate = args => {
  const {
    nextParams: {
      category_name: categoryName
    },
    nextUrl,
    defaultShouldRevalidate
  } = args;
  console.log("[shouldRevalidate] in feed category", args, categoryName);
  try {
    const feedDate = window.store.get($FeedData(categoryName));
    if (feedDate instanceof Promise) {
      return true;
    }
    window.store.set($PageLevelTraffic, _objectSpread(_objectSpread({}, window.store.get($PageLevelTraffic)), {}, {
      canonicalUrl: nextUrl.toString(),
      pageType: EPageType.feed,
      categoryId: ECategoryNameIDMap[categoryName]
    }));
    return false;
  } catch (e) {
    console.warn(">>>>>> error", JSON.stringify(e));
  }
  return defaultShouldRevalidate;
};
var FeedPage = class extends RemixPage {
  constructor() {
    super(...arguments);
    this.Body = FeedBody;
    this.Head = FeedHead;
  }
};
export { FeedPage as default, links, shouldRevalidate };